import {Component, ElementRef} from '@angular/core';
import {MessageGridSelected} from '../../messages/message-grid-selected';
import {DataRow} from '../../DoraData/data-row';
import {WidgetBaseGridComponent} from '../widget-base/widget-base-grid.component';
import {DoraProperty} from '../../Decorators/Decorator';
import {MessageLevelSelected} from '../../messages/message-level-selected';
import {MessageService} from '../../messages/message.service';
import {ConfigurationService} from '../../Configuration/configuration-service';
import {PublisherService} from '../../pusblisher/publisher.service';
import {HttpClient} from '@angular/common/http';
import {WidgetService} from '../widget.service';
import {TranslateService} from '@ngx-translate/core';
import {TranslationService} from '../../TranslationMarkers/translation.service';

@Component({
  selector: 'dora-data-grid-selector',
  template: ''
})
/**
 * Base widget
 */
export class DoraDataGridSelectorComponent extends WidgetBaseGridComponent {
  @DoraProperty
  private levelToManage = 0;

  protected dataRows: DataRow[] = [];

  protected fatherDataRow: DataRow = undefined;


  constructor(elementRef: ElementRef<any>,
              messageService: MessageService,
              configurationService: ConfigurationService,
              publisher: PublisherService,
              widgetService: WidgetService,
              http: HttpClient,
              translationService: TranslationService) {
    super(elementRef, messageService, configurationService, publisher, widgetService, http, translationService);

    this.disableMessageGridSelected = true;
  }

  onParameterInjectedFinished(): void {
    super.onParameterInjectedFinished();

    // level event
    if (this.levelToManage > 1) {
      this.messageService.getMessage(this.EventChannel, MessageLevelSelected, this.CallerName).subscribe(message => {
        const dataRow = (message.data as MessageLevelSelected).dataRow;

        if (dataRow.Level === this.levelToManage - 1) {
          // is my father
          this.fatherDataRow = dataRow;
          this.onNewData();
        }
      });
    }
  }

  protected selectedGrid(rowId: string): void {
    let dataRow: DataRow;
    dataRow = this.dataGrid.getDataRow(rowId);

    if (dataRow === null) {
      console.error('Row not found. Id: ' + rowId);
      return;
    }

    // check level
    if (this.levelToManage !== 0 && this.levelToManage !== dataRow.Level) {
      // don't handle
      return;
    }

    this.dataGrid.selectRowMutex(dataRow.Id);
    if (dataRow.GridId === '') {
      // no grid associated: signal level
      this.messageService.sendMessage(this.EventChannel, new MessageLevelSelected(dataRow), this.CallerName);
    } else {
      // selected grid
      this.messageService.sendMessage(this.EventChannel, new MessageGridSelected(dataRow.GridId, dataRow.Description), this.CallerName);
    }
  }

  /**
   * received new data or something is changed: rebuild list
   */
  protected onNewData(): void {
    super.onNewData();

    if (this.dataGrid === undefined) {
      return;
    }
    // no filter
    if (this.levelToManage === 0) {
      this.dataRows = this.dataGrid.DataRows;
    }
    // first level: return all levels 1
    if (this.levelToManage === 1) {
      this.dataRows =  this.dataGrid.DataRows.filter((value: DataRow) => {
        return value.Level === 1 ? true : false;
      });

      return;
    }

    // I'm child, level >= 2
    if (this.fatherDataRow === undefined) {
      // father not set exit
      return;
    }

    this.dataRows = [];
    let flFatherFound = false;
    for (const dataRow of this.dataGrid.DataRows) {
      if (flFatherFound === false) {
        if (dataRow.Id === this.fatherDataRow.Id) {
          // father found
          flFatherFound = true;
        }
      } else {
        if (dataRow.Level === this.levelToManage) {
          this.dataRows.push(dataRow);
        } else {
          break;
        }
      }
    }
    if (this.dataRows.length > 0) {
      this.selectedGrid(this.dataRows[0].Id);
    }
  }

}
